/*
  filter_search
*/
/**
 * Desktop Filter Search Module Management
 */

/************************************************
		PREPARE NOUI PLUGIN
*************************************************/

var filter_search_module = $("[class*=desk_filter_search-]");

//== if desk filter search is present on the page...
if (filter_search_module.length) {

  //== get element which will initiate nouislider
  var filter_search_price = document.getElementById("filter_search_price_slider");
  //== initiate plugin
  noUiSlider.create(filter_search_price, {
  	start: [ 20, 360 ],
    connect: true,
    behaviour: 'drag',
  	range: {
  		'min': [ 20, 1 ],
  		'max': [ 360, 1 ]
  	},
    format: wNumb({
			mark: '.',
			decimals: 0
		}),
  });


  var limitFieldMin = document.getElementById('filter_start_value');
  var limitFieldMax = document.getElementById('filter_end_value');

  filter_search_price.noUiSlider.on('update', function( values, handle ){
  	(handle ? limitFieldMax : limitFieldMin).innerHTML = values[handle];
  });

}
